export const GOOGLE_DOCS_BASE_URL = 'https://docs.google.com/document/d/';
